
import React from 'react';
import styled, { keyframes } from 'styled-components';

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const StyledSVG = styled.svg`
  animation: 2s ${rotate} linear infinite;
  height: ${({ size }) => size};
  width: ${({ size }) => size};
  display: block;
  path.cj-loader-arc {
    stroke: ${({ stroke, theme }) => stroke ?? theme?.primary1 ?? '#0d9488'};
  }
`;

export default function Loader({
    size = '24px',
    stroke,
    /** Subtle full ring behind the arc (reads better on busy backgrounds). */
    track = false,
    trackStroke = 'rgba(113, 113, 122, 0.28)',
    ...rest
}) {
    const arc = (
        <StyledSVG
            className="cj-loader-svg"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            size={size}
            stroke={stroke}
            {...rest}
        >
            <path
                className="cj-loader-arc"
                d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 9.27455 20.9097 6.80375 19.1414 5"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </StyledSVG>
    );

    if (!track) {
        return arc;
    }

    return (
        <span
            className="cj-loader-wrap"
            style={{
                position: 'relative',
                display: 'inline-flex',
                width: size,
                height: size,
                verticalAlign: 'middle',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <svg
                aria-hidden
                style={{ position: 'absolute', inset: 0 }}
                viewBox="0 0 24 24"
                width="100%"
                height="100%"
                fill="none"
            >
                <circle cx="12" cy="12" r="9.25" stroke={trackStroke} strokeWidth="1.75" />
            </svg>
            <span
                style={{
                    position: 'relative',
                    zIndex: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                {arc}
            </span>
        </span>
    );
}
